module.exports = {"320382001":"东湖街道","320382002":"运河街道","320382003":"戴圩街道","320382004":"炮车街道","320382102":"邳城镇","320382103":"官湖镇","320382104":"四户镇","320382105":"宿羊山镇","320382106":"八义集镇","320382107":"土山镇","320382108":"碾庄镇","320382109":"港上镇","320382110":"邹庄镇","320382111":"占城镇","320382112":"新河镇","320382113":"八路镇","320382115":"铁富镇","320382116":"岔河镇","320382118":"陈楼镇","320382119":"邢楼镇","320382120":"戴庄镇","320382121":"车辐山镇","320382122":"燕子埠镇","320382123":"赵墩镇","320382124":"议堂镇","320382401":"邳城农场","320382402":"张楼农场","320382403":"江苏邳州经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320382.json
// module id = 956
// module chunks = 0